export const siteConfig = {
  name: '征途国际',
  tagline: '经典征途 热血重燃',
  description: '征途国际App最新版官方下载安装，支持Android与iOS双平台，安全无病毒，一键安装即玩。经典征途国际手游焕新升级，海量玩法等你体验！',
  androidDownloadUrl: '#android-download',
  iosDownloadUrl: '#ios-download',
  version: 'v8.6.0',
  updateDate: '2026年8月10日',
  fileSize: '1.8GB',
};

export const navLinks = [
  { label: '首页', href: '/' },
  { label: '游戏攻略', href: '/category/strategy' },
  { label: '新闻资讯', href: '/category/news' },
  { label: '版本更新', href: '/category/updates' },
  { label: '关于我们', href: '/about' },
];

export const features = [
  {
    icon: 'ri-sword-line',
    title: '经典国战玩法',
    description: '万人同屏国战，十国争霸，热血沸腾的千人战场，感受真正的征途世界。',
  },
  {
    icon: 'ri-team-line',
    title: '兄弟帮会系统',
    description: '组建最强帮会，与兄弟并肩作战，抢夺王城，成为一方霸主。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '极品装备体系',
    description: '海量装备自由打造，星级品质、灵魂锁链，打造属于你的神装之路。',
  },
  {
    icon: 'ri-map-pin-user-line',
    title: '自由交易市场',
    description: '玩家自由交易，装备、材料、道具随心买卖，打造繁荣经济生态。',
  },
  {
    icon: 'ri-trophy-line',
    title: '跨服竞技对决',
    description: '跨服竞技场热血对决，实力为王，用战绩证明你的巅峰实力。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '双端互通畅玩',
    description: 'Android与iOS双平台数据互通，随时随地登录，征战不间断。',
  },
];

export const gameStats = [
  { value: '5000万+', label: '累计注册玩家' },
  { value: '8年', label: '经典运营时长' },
  { value: '200+', label: '服务器数量' },
  { value: '4.8', label: '玩家评分' },
];

export const faqs = [
  {
    question: '征途国际App是否免费下载？',
    answer: '是的，征途国际App完全免费下载安装。游戏内含有内购项目，玩家可根据自身需求选择购买，但不影响核心游戏体验。',
  },
  {
    question: 'Android和iOS版本数据互通吗？',
    answer: '完全互通！征途国际支持Android与iOS双平台数据实时同步，无论使用什么设备登录，您的角色、装备、进度都将完整保留。',
  },
  {
    question: '游戏最低配置要求是什么？',
    answer: 'Android设备需要Android 7.0及以上系统，至少4GB运行内存；iOS设备需要iOS 13.0及以上系统。建议使用近三年内发布的中高端机型以获得最佳游戏体验。',
  },
  {
    question: '下载安装包安全吗？有病毒吗？',
    answer: '本站提供的征途国际App均为官方正版安装包，经过多重安全检测，不含任何病毒、木马或恶意插件，请您放心下载。建议通过本站官方渠道下载以确保安全。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过关于我们页面的联系方式与我们取得联系，或直接在游戏内通过客服系统提交工单，我们将尽快为您解决问题。',
  },
  {
    question: '安装后无法启动怎么办？',
    answer: '请先确认您的设备满足最低配置要求。如仍无法启动，建议尝试清除应用缓存、重启设备或重新安装。如问题持续，请联系我们的客服团队获取技术支持。',
  },
];

export const categories = [
  { slug: 'strategy', name: '游戏攻略', icon: 'ri-book-open-line', description: '最新征途攻略，助你快速上手' },
  { slug: 'news', name: '新闻资讯', icon: 'ri-newspaper-line', description: '征途国际最新动态与公告' },
  { slug: 'updates', name: '版本更新', icon: 'ri-download-cloud-line', description: '版本更新日志与内容详解' },
  { slug: 'events', name: '活动福利', icon: 'ri-gift-line', description: '限时活动与福利领取攻略' },
];

export const articles = [
  {
    slug: 'zhengtu-xinshou-gonglve-2026',
    title: '征途国际2026新手入门完全攻略',
    category: 'strategy',
    categoryName: '游戏攻略',
    excerpt: '刚踏入征途国际的世界不知从何下手？本篇攻略从职业选择、升级路线到装备获取，手把手带你快速成长为一方霸主。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20warrior%20holding%20a%20glowing%20sword%20on%20a%20battlefield%20at%20sunset%2C%20epic%20fantasy%20game%20art%20style%2C%20dramatic%20lighting%2C%20golden%20and%20crimson%20tones%2C%20atmospheric%20mist%2C%20heroic%20pose%2C%20cinematic%20composition&width=800&height=400&seq=article-img-xinshou&orientation=landscape',
    date: '2026-08-10',
    readTime: '8分钟',
  },
  {
    slug: 'zhengtu-zhiye-xuanze-zhinan',
    title: '征途国际六大职业深度解析与选择指南',
    category: 'strategy',
    categoryName: '游戏攻略',
    excerpt: '战士、法师、弓手、仙术、刺客、召唤六大职业各有千秋。本文深度解析各职业技能特点、PVP与PVE表现，帮你找到最适合的职业。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Six%20different%20ancient%20Chinese%20warrior%20classes%20standing%20in%20formation%2C%20each%20with%20unique%20weapons%20and%20armor%2C%20epic%20fantasy%20illustration%2C%20rich%20warm%20color%20palette%2C%20cinematic%20lighting&width=800&height=400&seq=article-img-zhiye&orientation=landscape',
    date: '2026-08-05',
    readTime: '12分钟',
  },
  {
    slug: 'zhengtu-v860-gengxin-gonggao',
    title: '征途国际v8.6.0版本更新公告：全新跨服战场来袭',
    category: 'updates',
    categoryName: '版本更新',
    excerpt: '征途国际v8.6.0版本正式上线！全新跨服战场、装备觉醒系统、帮会联赛等重磅内容全面开放，赶快更新体验吧！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20fantasy%20battlefield%20with%20thousands%20of%20warriors%20clashing%2C%20epic%20scale%2C%20dramatic%20golden%20and%20red%20color%20scheme%2C%20cinematic%20game%20art%2C%20flying%20banners%20and%20flags&width=800&height=400&seq=article-img-gengxin&orientation=landscape',
    date: '2026-08-10',
    readTime: '5分钟',
  },
  {
    slug: 'zhengtu-banghui-liansai-gonglve',
    title: '征途国际帮会联赛制胜攻略：从报名到夺冠',
    category: 'strategy',
    categoryName: '游戏攻略',
    excerpt: '帮会联赛是征途国际最高荣誉的团队赛事。本文详解联赛规则、战术布局、人员配置等核心要素，助你的帮会问鼎冠军。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20army%20formation%20in%20epic%20battle%2C%20commander%20pointing%20forward%2C%20war%20banners%20waving%2C%20dramatic%20lighting%2C%20cinematic%20fantasy%20art%2C%20warm%20golden%20tones&width=800&height=400&seq=article-img-banghui&orientation=landscape',
    date: '2026-08-03',
    readTime: '10分钟',
  },
  {
    slug: 'zhengtu-xianli-huodong-fuli',
    title: '八月盛夏狂欢：征途国际限时活动福利汇总',
    category: 'events',
    categoryName: '活动福利',
    excerpt: '盛夏来袭，征途国际推出多重限时福利活动！登录送豪礼、双倍经验、限定皮肤限时获取，错过再等一年！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Festive%20ancient%20Chinese%20celebration%20scene%20with%20lanterns%20and%20fireworks%2C%20warm%20golden%20ambient%20light%2C%20game%20art%20style%2C%20joyful%20atmosphere%2C%20rich%20red%20and%20gold%20colors&width=800&height=400&seq=article-img-fuli&orientation=landscape',
    date: '2026-08-01',
    readTime: '6分钟',
  },
  {
    slug: 'zhengtu-zhuangbei-dazao-jiaocheng',
    title: '征途国际装备打造全流程教程：从白装到神装',
    category: 'strategy',
    categoryName: '游戏攻略',
    excerpt: '装备是征途国际战力的核心。本文全面解析装备品质提升、灵魂锁链激活、星级强化等核心机制，教你打造顶级神装。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20weapons%20and%20armor%20displayed%20on%20ornate%20stands%2C%20glowing%20magical%20effects%2C%20golden%20light%2C%20epic%20game%20art%20style%2C%20rich%20detail%2C%20warm%20amber%20tones&width=800&height=400&seq=article-img-zhuangbei&orientation=landscape',
    date: '2026-07-28',
    readTime: '15分钟',
  },
  {
    slug: 'zhengtu-guochan-zhanshu-fenxi',
    title: '征途国际国战战术深度分析：十国争霸制胜之道',
    category: 'strategy',
    categoryName: '游戏攻略',
    excerpt: '国战是征途国际最核心的玩法。从兵力部署、指挥调度到关键时刻的战术选择，全面解析国战胜负关键。',
    imageUrl: 'https://readdy.ai/api/search-image?query=Massive%20ancient%20Chinese%20castle%20siege%20battle%2C%20thousands%20of%20soldiers%2C%20siege%20weapons%2C%20dramatic%20sunset%20lighting%2C%20epic%20scale%2C%20cinematic%20fantasy%20art%2C%20warm%20crimson%20atmosphere&width=800&height=400&seq=article-img-guozhan&orientation=landscape',
    date: '2026-07-25',
    readTime: '10分钟',
  },
  {
    slug: 'zhengtu-xinbanben-yugao',
    title: '征途国际下个版本抢先看：全新职业即将登场',
    category: 'news',
    categoryName: '新闻资讯',
    excerpt: '征途国际开发团队透露，下个大版本将推出全新职业，同时开放新地图与副本。抢先了解最新开发动态！',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Chinese%20warrior%20silhouette%20in%20fog%2C%20hints%20of%20glowing%20golden%20energy%2C%20atmospheric%20and%20mysterious%2C%20game%20art%20style%2C%20warm%20dark%20tones%2C%20cinematic%20composition&width=800&height=400&seq=article-img-yugao&orientation=landscape',
    date: '2026-07-20',
    readTime: '4分钟',
  },
];